export default {
    // A
    addDirection: 'Add direction',
    analyzeYourVideo: 'Analyze your video transcripts and proofing comments to complete your edit request with precise AI assistance.',

    // C
    chooseColleague: 'Choose a colleague',
    chooseDirection: 'Choose direction',
    chooseExpert: 'Choose expert',
    colleaguesAndGuests: 'Colleagues and Guests',
    colleaguesAndGuestsSubtitle: 'Request videos from within your community and guest users',

    // E
    editsInProgressAlertTextPrefix: 'At least 5 edits are in progress for',
    editsInProgressAlertTextSuffix: 'this channel',
    editsInProgressAlertTitle: 'You have maxed your edit request for this channel',
    externalOpenLink: 'External Open Link',
    externalOpenLinkSubtitle: 'A convenient link to request videos from your network',

    // I
    industryExperts: 'Industry Experts',
    industryExpertsSubtitle: 'Pitch your soundbite idea to an industry expert thought leader',

    // K
    keepThisPageOpen: `Keep this page open, and you'll have a response in no time.`,

    // M
    modifyImproveAdditionalNotes: `Modify, improve, and add additional notes, or try again.`,

    // R
    request: 'Request',

    // S
    saveEdits: 'Save Edits',
    selectApprover: 'Select approver',

    // W
    whoWouldLikeApprove: 'Who would you like to help you approve this content?',
}
